var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('MarketingPoints'),_c('LessonContents',{attrs:{"colorCode":_vm.colorCode}}),_c('FunctionList'),_c('KidsTabs'),_c('MediaCoverage'),_c('Instruction')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }